// Admin
export const ADMIN = "admin";
export const ADMIN_USER = "admin/user";
export const ADMIN_CREATE_ACCOUNT = "admin/create-account";
export const ADMIN_BRAND = "admin/brand";
export const ADMIN_PRODUCTS = "admin/products";
export const ADMIN_BUYERS = "admin/buyers";
export const ADMIN_LOCATIONS = "admin/locations";
export const ADMIN_SEND_EMAIL_INVITES = "admin/send-email-invites";
export const ADMIN_USERS = "admin/admin-users";

// Auth

export const AUTH_LOGIN = "auth/login";
export const AUTH_REGISTER = "auth/register";

// Account

export const ACCOUNTS = "accounts";
export const ACCOUNT_STATE = "accounts/state";
export const ACCOUNT_SUBSCRIPTION = "accounts/subscription";
export const ACCOUNT_BUYERS_COUNT = "accounts/buyer-count";

// Brands

export const BRANDS = "brands";
export const BRAND_DETAILS = "brands/details";
export const BRAND_NAME_UPDATE = "brands/update-brand-name";
export const BRAND_MONTHLY_BUYERS = "brands/monthly-buyers";
export const BRAND_TOP_SELLING_PRODUCT = "brands/top-selling-product";
export const BRAND_PRODUCT_SALES = "brands/product-sales";
export const BRAND_MERGE = "brands/merge";
export const BRAND_DETACH = "brands/detach";

// Buyers

export const BUYERS = "buyers";
export const BUYERS_UPLOAD = "buyers/upload";
export const BUYERS_QUICKBOOKS = "buyers/quickbooks";
export const BUYERS_LOCATIONS = "buyers/locations";

// Distributors
export const DISTRIBUTORS = "distributors";
export const DISTRIBUTOR_DETAILS = "distributors/details";
export const DISTRIBUTOR_NAME_UPDATE = "distributors/update-distributor-name";
export const DISTRIBUTORS_LIST = "distributors/list";
export const DISTRIBUTOR_TOGGLE_SHOW_PRICE = "distributors/toggle-show-price";
export const DISTRIBUTOR_BUYERS = "distributors/buyers";
export const DISTRIBUTOR_SALESREP_LOCATIONS = "distributors/sales-rep/locations";

//Importers
export const IMPORTERS = "importers";
export const IMPORTERS_DETAILS = "importers/users";

// Sales
export const SALES = "sales";
export const SALES_PRODUCTS = "sales/products";
export const SALES_UPLOAD = "sales/upload";
export const SALES_PRODUCT_SALE = "sales/product-sales";
export const SALES_RECORD = "sales/records";
export const SALES_STATS = "sales/stats";
export const SALES_REP_REPORT = "sales/sales-rep-report";
export const SALES_REP_QUARTERLY_REPORT = "sales/sales-rep-quarterly-report";
export const SALES_TERRITORY_REPORT = "sales/territory-report";
export const SALES_TERRITORY_QUARTERLY_REPORT = "sales/territory-quarterly-report";
export const SALES_PRODUCT_SALES = "sales/product-sales";
export const SALES_BUYER_RECENT_PURCHASE = "sales/recent-purchases";

// Locations
export const LOCATION_BUYERS = "locations/buyers";

// Connections

export const CONNECTIONS = "connections";
export const CONNECTIONS_BRAND = "connections/brand";
export const CONNECTIONS_BRAND_DISTRIBUTOR = "connections/brand-distributor";
export const CONNECTIONS_NON_CONNECTED_BRANDS = "connections/nonconnected-brands";
export const CONNECTIONS_NON_CONNECTED_DISTRIBUTORS = "connections/nonconnected-distributors";
export const CONNECTIONS_DISTRIBUTORS = "connections/distributor";
export const CONNECTIONS_REQUEST_BY_ADMIN = "connections/request-by-admin";
export const CONNECTIONS_REQUEST_BY_BRAND = "connections/request-by-brand";
export const CONNECTIONS_REQUEST_BY_DISTRIBUTOR = "connections/request-by-distributor";
export const CONNECTIONS_BRAND_REQUEST = "connections/brand-request";

// Activity Feed
export const ACTIVITY_FEED = "activity-feed";

//Payments

export const PAYMENT = "payment";
export const PAYMENT_DETAILS = "stripe/payments";

// Faire

export const FAIRE_STATUS = "faire/status";
export const FAIRE_REVOKE = "faire/revoke";
export const FAIRE_INVOICES = "faire/invoices";

// Quickbooks

export const QUICKBOOKS = "quickbooks";
export const QUICKBOOKS_AUTH = "quickbooks/auth";
export const QUICKBOOKS_INVOICE = "quickbook-invoice";
export const QUICKBOOKS_INVOICES_BRAND = "quickbook-invoice/brand";
export const QUICKBOOKS_SAVE_TOKEN = "quickbooks/save-quickbooks-token";
export const QUICKBOOKS_STATUS = "quickbooks/status";

//Notes
export const NOTES = "notes";
export const NOTES_BUYERS = "notes/buyer";

// Products

export const PRODUCTS = "products";
export const PRODUCTS_UPLOAD = "products/upload";
export const PRODUCTS_MERGE = "products/merge";
export const PRODUCTS_DETACH = "products/detach";
export const PRODUCTS_AVAILABLE_PRODUCTS = "products/availableProducts";
export const PRODUCTS_LOW_INVENTORY = "products/lowInventory";
// States

export const STATES = "states";

// Sales Unit
export const SALES_UNIT = "sales-unit";

// Stripe
export const STRIPE_CREATE_CHECKOUT = "stripe/create/checkout";
export const STRIPE_CANCEL_SUBSCRIPTION = "stripe/cancel-subscription";
export const SUBSCRIPTION_STATUS = "stripe/subscription-status";
export const STRIPE_SUBSCRIPTION = "stripe/subscription";
export const CARD_DETAILS = "stripe/card-details";

// Product Sale Units
export const PRODUCT_SALE_UNITS = "product-sales-unit";

// Users

export const USERS = "users";
export const USER_LOCATION = "users/location";
export const USER_ADD_USER = "users/add-user";
export const USER_PASSWORD_CHANGED = "users/change-user-password";
export const USER_CHANGED_PASSWORD = "users/change-password";
